// ----------------------------------------------------------------------

const account = {
  displayName: ' ',
  email: '',
  photoURL: '/static/mock-images/avatars/avatar_default.jpg'
};

export default account;
